import create from "zustand";

import {
  IDashboardApplication,
  IDashboardStakingInfo,
  IDashboardTokenAccountInfo,
  IDashboardTreasury,
  IDepositData,
  IMembersClubData,
  IProposalData,
  IWithdrawalDataDashboard,
} from "../common/interfaces/user-dashboard.interface";
import { DashboardActiveStep } from "../common/enums/dashboard.enums";

interface IDashboardData {
  clubs: IMembersClubData[] | undefined;
  splProposals: IProposalData[] | undefined;
  activeStep: DashboardActiveStep;
  withdrawals: IWithdrawalDataDashboard[] | undefined;
  deposits: IDepositData[] | undefined;
  treasuryData: (IDashboardTreasury | null)[] | undefined;
  applications: IDashboardApplication[] | undefined;
  invitations: IMembersClubData[] | undefined;
  stakings: IDashboardStakingInfo[] | undefined;
  initialLoading: boolean;
  treasuryTokens: IDashboardTokenAccountInfo[] | undefined;
  treasuryTokensLoading: boolean;
  masterClubs?: IMembersClubData[] | undefined;
}

interface IDashboardStore extends IDashboardData {
  setClubs: (clubs: IMembersClubData[] | undefined) => void;
  setSplProposals: (proposals: IProposalData[] | undefined) => void;
  setActiveStep: (step: DashboardActiveStep) => void;
  setWithdrawals: (withdrawals: IWithdrawalDataDashboard[] | undefined) => void;
  setDeposits: (deposits: IDepositData[] | undefined) => void;
  setTreasuryData: (
    treasury: (IDashboardTreasury | null)[] | undefined
  ) => void;
  setApplications: (applications: IDashboardApplication[]) => void;
  setInvitations: (invitations: IMembersClubData[] | undefined) => void;
  setStakings: (stakings: IDashboardStakingInfo[] | undefined) => void;
  setInitialLoading: (loading: boolean) => void;
  resetState: () => void;
  setTreasuryTokens: (
    treasury: IDashboardTokenAccountInfo[] | undefined
  ) => void;
  setTreasuryTokensLoading: (loading: boolean) => void;
  setMasterClubs: (masterClubs: IMembersClubData[] | undefined) => void;
}

const initialState: IDashboardData = {
  clubs: undefined,
  splProposals: undefined,
  activeStep: DashboardActiveStep.Dashboard,
  withdrawals: undefined,
  deposits: undefined,
  treasuryData: undefined,
  applications: undefined,
  invitations: undefined,
  stakings: undefined,
  initialLoading: false,
  treasuryTokens: undefined,
  treasuryTokensLoading: false,
  masterClubs: undefined,
};

export const dashboardStore = create<IDashboardStore>((set) => ({
  ...initialState,
  setClubs: (clubs: IMembersClubData[] | undefined) => set(() => ({ clubs })),
  setSplProposals: (proposals: IProposalData[] | undefined) =>
    set(() => ({ splProposals: proposals })),
  setActiveStep: (step: DashboardActiveStep) =>
    set(() => ({ activeStep: step })),
  setWithdrawals: (withdrawals: IWithdrawalDataDashboard[] | undefined) =>
    set(() => ({ withdrawals })),
  setDeposits: (deposits: IDepositData[] | undefined) =>
    set(() => ({ deposits })),
  setTreasuryData: (treasury: (IDashboardTreasury | null)[] | undefined) =>
    set(() => ({ treasuryData: treasury })),
  setApplications: (applications: IDashboardApplication[]) =>
    set(() => ({ applications })),
  setInvitations: (invitations: IMembersClubData[] | undefined) =>
    set(() => ({ invitations })),
  setStakings: (stakings: IDashboardStakingInfo[] | undefined) =>
    set(() => ({ stakings })),
  setInitialLoading: (loading: boolean) =>
    set(() => ({ initialLoading: loading })),
  setTreasuryTokens: (treasury: IDashboardTokenAccountInfo[] | undefined) =>
    set(() => ({ treasuryTokens: treasury })),
  resetState: () => set(() => initialState),
  setTreasuryTokensLoading: (loading: boolean) =>
    set(() => ({ treasuryTokensLoading: loading })),
  setMasterClubs: (masterClubs: IMembersClubData[] | undefined) =>
    set(() => ({ masterClubs })),
}));
